module.exports = __webpack_public_path__ + "img/page9img2.6ab202f5.png";